export const ProcessSection = () => {
  const phases = [
    {
      step: "01",
      title: "Discovery",
      description: "Understanding your business goals and target market"
    },
    {
      step: "02",
      title: "Design",
      description: "Creating intuitive and conversion-focused interfaces"
    },
    {
      step: "03",
      title: "Development",
      description: "Building your store with scalable architecture"
    },
    {
      step: "04",
      title: "Launch & Growth",
      description: "Ongoing optimization and marketing support"
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Our Development Process</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            A proven approach to building successful online stores
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-8">
          {phases.map((phase, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 rounded-full bg-blue-600 text-white flex items-center justify-center text-xl font-bold mx-auto mb-4">
                {phase.step}
              </div>
              <h3 className="text-xl font-semibold mb-2">{phase.title}</h3>
              <p className="text-gray-600">{phase.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};